import { ETranscoderTaskStatus, TranscoderTemplate, TranscoderWorkerType } from '.';
import { TranscoderAsset } from './asset';
import { TranscoderReservedNames } from './reservedName';

export type TranscoderWorker = {
  name: TranscoderWorkerType;
  total: number;
  available: number;
};

export type TranscoderEncoder = {
  uuid: string;
  id: string;
  model: string;
  type: string;
};

export type TranscoderSelector = { index: number; pid: number; mediaType?: 'audio' | 'video' };
export type TranscoderSelectors = TranscoderSelector[];

export type TranscoderTaskInput = {
  url: string;
};

export type TranscoderStream = {
  format: string;
  url: string;
  name?: string;
  audioProfiles?: { index: number }[];
  videoProfiles?: { index: number }[];
};

export type EncoderTypeWithId = { encoderId?: TranscoderEncoder['id']; encoderType?: TranscoderEncoder['type'] };

export type TranscoderTask = {
  id: string;
  name: string;
  description?: string;
  input: TranscoderTaskInput[];
  streams: TranscoderStream[];
  videoMap: TranscoderSelectors;
  audioMap: TranscoderSelectors;
  templateId?: string;
  template: TranscoderTemplate;
  failReason: string;
  state: ETranscoderTaskStatus;
  reservedNames?: TranscoderReservedNames[];
  restartRequired?: boolean;
  outputFolder?: string;
  kind: ETranscoderTaskKind;
  assets: TranscoderAsset[];
  isEnabled?: boolean;
  multiOutput?: boolean;
  restartOnPmt?: boolean;
  scheduledRestart?: ScheduledRestart;
  workerId?: number;
  workerName: string;
  eventCount?: number;
  hasSlot?: boolean; // applied internally in frontend
} & EncoderTypeWithId;

export type ScheduledRestart = {
  restartAt?: string;
};

export const enum ETranscoderTaskKind {
  vod = 'vod',
  live = 'live',
}
